import React, { FC, useState } from 'react';
import { SingleFieldModal } from '../../../SingleFieldModal';
import { InsuranceFormSubmissionStatus } from '../../../../Utils/types';
import { useInsuranceLabels } from '../../../../Utils/Context/labelsContext';
import { ContactApi } from '../../../../../Api/ContactApi';

interface ReportErroModalProps {
  onClose: () => void;
}

export const ReportErrorModal: FC<ReportErroModalProps> = (props) => {
  const { onClose } = props;
  const [formSubmissionStatus, setFormSubmissionStatus] = useState<InsuranceFormSubmissionStatus>('initial');
  const {
    buttons,
    headings,
    labels,
    inputs
  } = useInsuranceLabels();
  const contactApi = new ContactApi();

  const onSubmit = async (message: string) => {
    if (formSubmissionStatus === 'loading') return;
    setFormSubmissionStatus('loading')
    try {
      await contactApi.sendErrorMail({message: message});
      setFormSubmissionStatus('success');
    } catch (error) {
      setFormSubmissionStatus('error');
    }
  };

  return (
    <SingleFieldModal
      id="reportErrorModal"
      header={headings.reportErrorHeading}
      subHeader={headings.reportErrorSubHeading}
      submitButtonLabel={buttons.reportErrorSubmitButtonLabel}
      submitButtonIcon="s-checkmark"
      closeButtonLabel={buttons.reportErrorCloseModalButtonLabel}
      inputLabel={inputs.reportErrorLabel}
      inputPlaceholder={inputs.reportErrorPlaceholder}
      successMessage={labels.reportErrorSubmissionSuccess}
      errorMessage={labels.reportErrorSubmissionError}
      onClose={onClose}
      onSubmit={onSubmit}
      formSubmissionStatus={formSubmissionStatus}
    />
  );
};
